// extracted by mini-css-extract-plugin
module.exports = {"container":"Total_container__2MKZb","types":"Total_types__bxd0c","title":"Total_title__1cQoY","listItem":"Total_listItem__2s82g","image":"Total_image__NU5Ov"};